import { apiClient } from '../../api/client';
import { UserOptions as UserOptionsType } from '../../types/chat';

export async function UserOptions(): Promise<UserOptionsType> {
  try {
    const response = await apiClient.users.usersUserOptionsRetrieve();
    return response.data as UserOptionsType;
  } catch (error) {
    console.error('Error fetching user options:', error);
    throw error;
  }
}
